import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/marketing-tool.png'


const _hoisted_1 = {
  class: "border-0 rounded-3 mb-4 text-center",
  style: {"background":"linear-gradient(162deg, #d7b5fd 3.82%, #9947f5 98.54%)"}
}
const _hoisted_2 = { class: "card-body p-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-24 d-block text-secondary" }, "Want To Try", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "fs-24 text-secondary" }, [
        _createTextVNode(" New Marketing "),
        _createElementVNode("br"),
        _createTextVNode(" Tool? ")
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "py-4 mb-3" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "marketing-tool"
        })
      ], -1)),
      _createVNode(_component_RouterLink, {
        to: "/contact",
        class: "d-inline-block py-2 px-4 btn btn-primary border-0",
        style: {"background-color":"#6a22a7"}
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Contact Us ")
        ])),
        _: 1
      })
    ])
  ]))
}